__webpack_require__.p = "https://dev.softsprint.ae/";